import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue';
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
// import VTreeview from './components/story-edit-view/vtreeview'
import 'vuetify/dist/vuetify.min.css'
import { store } from './store'
import VueFire from 'vuefire'
import {Firebase} from './firebaseDB'
import vueVimeoPlayer from 'vue-vimeo-player'
import VueProgressBar from 'vue-progressbar'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.use(Vuetify, {
  theme: {
    primary: '#47b784',
    accent: '#2E7D32',
    secondary: '#34495e',
    info: '#0D47A1',
    warning: '#ffb300',
    error: '#B71C1C',
    success: '#2E7D32'
  }
})
// Vue.use(VTreeview)

const options = {
  color: '#bffaf3',
  failedColor: '#874b4b',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  location: 'top',
  inverse: false
}

Vue.use(VueProgressBar, options)

Vue.use(VueFire)
Vue.use(vueVimeoPlayer)
Vue.use(BootstrapVue);

Vue.config.productionTip = false

/* eslint-disable no-new */
// import customized components globally
// register in firebase
const unsubscribe = Firebase.auth()
.onAuthStateChanged((firebaseUser) => {
  new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),
    created () {
      if (firebaseUser) {
        store.dispatch('autoSignIn', firebaseUser)
      }
    }
  })
  unsubscribe()
})



// WEBPACK FOOTER //
// ./src/main.js